import { useState, useEffect, useContext } from 'react'
import { useFormik } from "formik"
import axios from 'axios'
import * as Yup from "yup"
import ContextStates from '../../context/ContextStates'
import { Url } from '../Url'
import { FaUser, FaMapMarkerAlt, FaPhoneAlt, FaCheckCircle, FaUndoAlt, FaSignOutAlt } from 'react-icons/fa'

const FormCliente = () => {
    const [guardar, setGuardar] = useState(true);
    const { setViewOpen, modify, setModify, formPrev, setFormPrev, setFormView, idUsuario, setClienteSelected } = useContext(ContextStates);

    const formik = useFormik({
        initialValues: {
            apellido: '',
            nombre: '',
            /*razonSocial: '',
            cuit: '',
            documento: '',*/
            domicilio: '',
            telefono: ''
        },
        validationSchema: Yup.object({
            apellido: Yup.string()
                .required("El apellido es necesario"),
            nombre: Yup.string()
                .required("El nombre es necesario"),
            /*razonSocial: Yup.string(),
            cuit: Yup.string(),
            documento: Yup.string(),*/
            domicilio: Yup.string(),
            telefono: Yup.string()

        }),
        onSubmit: async (valores, { resetForm }) => {
            const formData = new FormData()
            if (guardar) {
                setGuardar(false)
                formData.append('apellido', valores.apellido);
                formData.append('nombre', valores.nombre);
                /*formData.append('razonsocial', valores.razonSocial);
                formData.append('cuit', valores.cuit);
                formData.append('documento', valores.documento);*/
                formData.append('domicilio', valores.domicilio);
                formData.append('telefono', valores.telefono);
                formData.append('idusuario', idUsuario);
                try {
                    const response = await axios({
                        url: Url + 'api/clientesAlta.php',
                        method: 'POST',
                        data: formData,
                    })
                    console.log(response)
                    let aux = modify + 1;
                    setModify(aux);
                    const newClient = {
                        id: response.data.results.idcliente,
                        apellido: valores.apellido,
                        nombre: valores.nombre,
                        razonsocial: valores.razonSocial || '',
                        cuit: valores.cuit || '',
                        documento: valores.documento || '',
                        domicilio: valores.domicilio || '',
                        telefono: valores.telefono || '',
                        value: response.data.results.idcliente,
                        label: `${valores.apellido}, ${valores.nombre}`
                    };
                    setClienteSelected(newClient);
                    if (formPrev!==0)
                        handleReturn();
                    resetForm({ values: '' });
                } catch (e) {
                    console.log(e)
                }
            }
        }
    });

    /*useEffect(() => {
        const checkCliente = async () => {
            const formData = new FormData()
            formData.append('documento', formik.values.documento);
            formData.append('cuit', formik.values.cuit);
            try {
                const response = await axios({
                    url: Url + 'api/checkCliente.php',
                    method: 'POST',
                    data: formData,
                })
                if (response.data.results.id !== 0) {
                    switch (response.data.results.error) {
                        case '1':
                            setErrorDocumento(true)
                            break;
                        case '2':
                            setErrorCuit(true)
                            break;
                        case '3':
                            setErrorDocumento(true)
                            setErrorCuit(true)
                            break;

                        default:
                            setErrorDocumento(false)
                            setErrorCuit(false)
                            break;
                    }
                }
            } catch (e) {
            }
        }
        checkCliente()
    }, [formik.values.documento, formik.values.cuit])*/

    const handleReturn = () => {
        setFormView(formPrev)
        setFormPrev(0)
    }

    return (
        <form
            className="w-full mx-auto p-6 sm:p-8 bg-white"
            onSubmit={formik.handleSubmit}
        >
            <div className="w-full">
                <div className='flex flex-col items-center justify-center mb-8 text-indigo-600'>
                    <div className='bg-indigo-50 p-4 rounded-full mb-3 text-3xl shadow-inner'>
                        <FaUser className='text-indigo-600' />
                    </div>
                    <h2 className='text-3xl font-extrabold text-gray-800 tracking-tight'>Nuevo Cliente</h2>
                    <p className='text-sm text-gray-400 mt-1'>Registra un cliente para asociarlo con ventas</p>
                </div>

                <div className='grid grid-cols-1 sm:grid-cols-2 gap-6'>
                    <div className="w-full">
                        <label htmlFor="apellido" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Apellido</label>
                        <div className="relative">
                            <input
                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 transition-all duration-200"
                                id="apellido"
                                placeholder="Ingrese el apellido"
                                type="text"
                                value={formik.values.apellido}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                autoFocus
                            />
                        </div>
                        {formik.touched.apellido && formik.errors.apellido ? (
                            <div className='w-full block mt-2 text-xs text-red-500 font-semibold'>
                                <p>{formik.errors.apellido}</p>
                            </div>
                        ) : null}
                    </div>

                    <div className="w-full">
                        <label htmlFor="nombre" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Nombre</label>
                        <div className="relative">
                            <input
                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 transition-all duration-200"
                                id="nombre"
                                placeholder="Ingrese el nombre"
                                type="text"
                                value={formik.values.nombre}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </div>
                        {formik.touched.nombre && formik.errors.nombre ? (
                            <div className='w-full block mt-2 text-xs text-red-500 font-semibold'>
                                <p>{formik.errors.nombre}</p>
                            </div>
                        ) : null}
                    </div>
                </div>

                <div className="w-full mt-6">
                    <label htmlFor="domicilio" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Domicilio</label>
                    <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                            <FaMapMarkerAlt />
                        </span>
                        <input
                            className="w-full pl-10 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 transition-all duration-200"
                            id="domicilio"
                            placeholder="Ingrese Domicilio"
                            type="text"
                            value={formik.values.domicilio}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </div>

                <div className="w-full mt-6 mb-8">
                    <label htmlFor="telefono" className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Nº de Teléfono</label>
                    <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                            <FaPhoneAlt />
                        </span>
                        <input
                            className="w-full pl-10 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 transition-all duration-200"
                            id="telefono"
                            placeholder="Ingrese Nº de Teléfono"
                            type="text"
                            value={formik.values.telefono}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                    </div>
                </div>
            </div>

            <div className="border-t border-gray-100 pt-6">
                <div className="w-full flex flex-col-reverse sm:flex-row justify-end gap-3">
                    {formPrev === 0 ? (
                        <button
                            type="button"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-xl transition-all duration-200 uppercase tracking-wide text-xs"
                            onClick={() => setViewOpen(false)}
                        >
                            <FaSignOutAlt className="text-sm" />
                            Salir
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-xl transition-all duration-200 uppercase tracking-wide text-xs"
                            onClick={() => handleReturn()}
                        >
                            <FaUndoAlt className="text-sm" />
                            Regresar
                        </button>                        
                    )}

                    <button
                        type="submit"
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all duration-200 uppercase tracking-wide text-xs"
                    >
                        <FaCheckCircle className="text-sm" />
                        Guardar Datos
                    </button>
                </div>
            </div>
        </form>
    )
}

export default FormCliente